<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">大型设备进场管理</el-breadcrumb-item>
      <el-breadcrumb-item>大型设备预约管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="手机号" prop="phone">
            <el-input size="small" style="width: 200px;" v-model="formInline.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>

          <el-form-item label="展会名称" prop="exhibitionId">
            <el-select v-model="formInline.exhibitionId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in exhList"
                :key="item.id"
                :label="item.exhibitionName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="展会号" prop="boothNumber">
            <el-input size="small" style="width: 200px;" v-model="formInline.boothNumber" placeholder="请输入展会号"></el-input>
          </el-form-item>


          <el-form-item label="状态" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in statusSelect"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="卸货方式" prop="unloadId">
            <el-select v-model="formInline.unloadId" placeholder="请选择状态">
              <el-option label="叉车" :value = 1 ></el-option>
              <el-option label="吊车" :value = 2 ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="时间" prop="baseForm">
            <el-date-picker style="width: 370px;"
                            v-model.trim="baseForm"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>


          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column prop="exhibitionName" label="展会名称" align="center"></el-table-column>
          <el-table-column prop="boothNumber" label="展会号" align="center"></el-table-column>
          <el-table-column prop="name" label="负责人" align="center"></el-table-column>
          <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
          <el-table-column prop="agreement" label="进馆约定书" align="center" >
            <template slot-scope="scope">
              <div v-if="scope.row.agreement != null && scope.row.agreement != ''">
                <el-popover placement="top-start" trigger="hover">
                  <a :href="scope.row.agreement" target="_blank" title="查看最大化图片"><img :src="scope.row.agreement" style="width: 300px;height: 300px" /></a>
                  <img slot="reference" :src="scope.row.agreement" style="width: 100px;height: 100px; cursor:pointer" />
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="进馆时间" align="center">
            <template slot-scope="scope">
              <div> {{scope.row.beginTime|timestampToTime}}--{{scope.row.endTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column prop="unloadId" label="卸货方式" align="center">
            <template slot-scope="scope">
              <el-tag type="danger" v-if="scope.row.unloadId==1">叉车</el-tag>
              <el-tag type="info" v-if="scope.row.unloadId==2">吊车</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==1">已预约</el-tag>
              <el-tag type="danger" v-if="scope.row.status==2">已拒绝</el-tag>
              <el-tag type="info" v-if="scope.row.status==3">已结束</el-tag>
              <el-tag v-if="scope.row.status==0">待审核</el-tag>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="statusEnt(scope.row.id,1)"style="width: 100px;margin: 1px;" v-if="scope.row.status == 0">同意</el-button>
              <el-button size="mini" type="warning" @click="statusEnt(scope.row.id,2)"style="width: 100px;margin: 1px;" v-if="scope.row.status == 0">拒绝</el-button>
              <el-button size="mini" type="success" @click="ents(scope.$index, scope.row)"style="width: 100px;margin: 1px;">大型设备信息</el-button>
              <el-button size="mini" type="success" @click="cars(scope.$index, scope.row)"style="width: 100px;margin: 1px;">车辆信息</el-button>
              <el-button size="mini" type="danger" @click="deleteData(scope.row.id)"style="width: 100px;margin: 1px;" v-if="scope.row.status == 1">提前结束</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


<!--        车辆信息修改-->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form>
            <el-table :data="editForm.equipmentCars">
              <el-table-column prop="licencePlate" label="车牌号">
                <template slot-scope="scope">
                  <el-input placeholder="请输入车牌号" v-model="scope.row.licencePlate"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="carLength" label="车长">
                <template slot-scope="scope">
                  <el-input placeholder="请输入车长" v-model="scope.row.carLength"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="driver" label="司机姓名">
                <template slot-scope="scope">
                  <el-input placeholder="请输入司机姓名" v-model="scope.row.driver"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="phone" label="司机电话">
                <template slot-scope="scope">
                  <el-input placeholder="请输入司机电话" v-model="scope.row.phone"></el-input>
                </template>
              </el-table-column>


            </el-table>
            <el-button style="padding-bottom: 10px;  margin-bottom: 20px; margin-left: 1000px;margin-top: 10px;"
                       type="primary" :loading="loading" :disabled="isDisabled"
                       @click="cardSubmitForm()">保存</el-button>
          </el-form>
        </el-dialog>



        <!--        大型设备信息修改-->
        <el-dialog :title="title" :visible.sync="editFormVisibleEnt" width="60%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form>
            <el-table :data="editForm.equipments">

              <el-table-column prop="model" label="机型">
                <template slot-scope="scope">
                  <el-input placeholder="请输入机型" v-model="scope.row.model"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="weight" label="重量">
                <template slot-scope="scope">
                  <el-input placeholder="请输入重量" v-model="scope.row.weight"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="size" label="尺寸">
                <template slot-scope="scope">
                  <el-input placeholder="请输入尺寸" v-model="scope.row.size"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="protection" label="保护措施">
                <template slot-scope="scope">
                  <el-input placeholder="请输入保护措施" v-model="scope.row.protection"></el-input>
                </template>
              </el-table-column>

            </el-table>
            <el-button style="padding-bottom: 10px;  margin-bottom: 20px; margin-left: 1000px;margin-top: 10px;"
                       type="primary" :loading="loading" :disabled="isDisabled"
                       @click="entSubmitForm()">保存</el-button>
          </el-form>
        </el-dialog>


      </el-main>
    </el-container>
  </div>
</template>

<script>



import {qryEntranceList,upEntranceStatus,upCars,upEnts,upStatusEnd} from '../../api/examApi'
import {qryExhibitionList} from '../../api/courseApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import {upStatus} from "../../api/rankingApi";


export default {
  name: "questionTopicList",
  data() {
    return {
      title:'添加',
      editFormVisible:false,
      editFormVisibleEnt:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        unloadId:'',
        phone:'',
        exhibitionId:'',
        boothNumber:'',
        beginTime:'',
        endTime:'',
        status:'',
        page:1,
        pageSize:10
      },
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      baseForm: '',
      editForm:{
        id:'',
        exhibitionId:'',
        exhibitionName:'',
        boothNumber:'',
        userId:'',
        name:'',
        phone:'',
        unloadId:'',
        agreement:'',
        status:'',
        equipmentCars:[],
        equipments:[],
        beginTime:'',
        endTime:'',
      },
      statusSelect:[{"name":"已预约","value":"1"},
        {"name":"已拒绝","value":"2"},
        {"name":"已结束","value":"3"},
        {"name":"待审核","value":"0"}],


      exhList:[],
    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      if (this.baseForm != ''&& this.baseForm != null) {

        // 开始时间
        this.formInline.beginTime = this.$moment(`${this.baseForm[0]}`)
        // 结束时间
        this.formInline.endTime = this.$moment(`${this.baseForm[1]}`)
      } else {
        // 删除开始时间
        delete this.formInline.beginTime;
        // 删除结束时间
        delete this.formInline.endTime;
      }
      qryEntranceList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })

      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
      })

    },

    resetFrom(){
      this.formInline.unloadId = '';
      this.formInline.phone = '';
      this.formInline.exhibitionId = '';
      this.formInline.boothNumber = '';
      this.formInline.status = '';
      this.baseForm = [];
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },


    statusEnt(id,status) {
      this.$confirm('确认要修改状态吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data={
          id:id,
          status:status
        }
        upEntranceStatus(data).then(res =>{
          if (res.code==1) {
            this.$message({
              type: 'success',
              message: '数据保存成功！'
            })
            this.tableList(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.$message.error('保存失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },

    //显示编辑界面
    cars: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '车辆信息修改'
        this.editForm.equipmentCars = row.equipmentCars
      }
    },

    ents: function(index, row) {
      this.editFormVisibleEnt = true
      if (row != undefined && row != 'undefined') {
        this.title = '大型设备信息修改'
        this.editForm.equipments = row.equipments
      }
    },

    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.baseForm = [];
      this.editFormVisible = false;
    },
    handleAvatarSuccessImage(res) {
      this.editForm.image = res.data;
    },
    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },


    // 编辑、添加提交方法
    cardSubmitForm() {
      this.isDisabled = true;
      upCars(this.editForm.equipmentCars).then(res =>{
        if (res.code==1) {
          this.editFormVisible = false
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
        this.isDisabled = false;
      }).catch(err => {
        this.editFormVisible = false
        this.$message.error('保存失败，请稍后再试！')
        this.isDisabled = false;
      })
    },

    entSubmitForm() {
      this.isDisabled = true;
      upEnts(this.editForm.equipments).then(res =>{
        if (res.code==1) {
          this.editFormVisibleEnt = false
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
        this.isDisabled = false;
      }).catch(err => {
        this.editFormVisibleEnt = false
        this.$message.error('保存失败，请稍后再试！')
        this.isDisabled = false;
      })
    },

    deleteData(id) {
      this.$confirm('确定要提前结束预约吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          upStatusEnd({id:id})
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据已更新!'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },



  },
  //分页组件
  components: {
    ElInputNumber,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/exam/questionTopicList.vue